import { render, staticRenderFns } from "./shrinkImg.vue?vue&type=template&id=0c869e7c&scoped=true&"
import script from "./shrinkImg.vue?vue&type=script&lang=js&"
export * from "./shrinkImg.vue?vue&type=script&lang=js&"
import style0 from "./shrinkImg.vue?vue&type=style&index=0&id=0c869e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c869e7c",
  null
  
)

export default component.exports